import { render, staticRenderFns } from "./HomeAdminTab2.vue?vue&type=template&id=b5ef74b8&scoped=true"
import script from "./HomeAdminTab2.vue?vue&type=script&lang=js"
export * from "./HomeAdminTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ef74b8",
  null
  
)

export default component.exports